import React from 'react';
import { Button } from './ui/button';

const ConfidentTradingSection = () => {
  return (
    <section className="relative pt-20 pb-0 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-black"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-yellow-900/5 to-transparent"></div>
      
      {/* Floating particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-yellow-500/30 rounded-full animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${10 + Math.random() * 15}s`
            }}
          ></div>
        ))}
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Section Title with animation */}
        <h2 className="text-5xl md:text-6xl font-bold text-center mb-20 animate-fade-in-up">
          <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
            On your way
          </span>
          <br />
          <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
            to{' '}
          </span>
          <span className="text-yellow-500 inline-block animate-pulse-glow">confident trading</span>
        </h2>

        {/* Features Grid */}
        <div className="space-y-10">
          {/* Design 9 */}
          <div className="flex justify-center animate-slide-in-left">
            <div className="relative max-w-4xl w-full glass rounded-2xl group hover:scale-105 transition-all duration-500 overflow-hidden">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-yellow-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-2xl"></div>
              
              <div className="relative">
                <img 
                  src="/images/Design 9.png" 
                  alt="Design 9" 
                  className="w-full h-auto object-contain transform group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Design 10 */}
          <div className="flex justify-center animate-slide-in-right">
            <div className="relative max-w-4xl w-full glass rounded-2xl group hover:scale-105 transition-all duration-500 overflow-hidden">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-yellow-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-2xl"></div>
              
              <div className="relative">
                <img 
                  src="/images/Design 10.png" 
                  alt="Design 10" 
                  className="w-full h-auto object-contain transform group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Ready-to-use Strategies */}
          <div className="grid md:grid-cols-2 gap-12 items-center animate-slide-in-left">
            <div className="space-y-6">
              <h3 className="text-4xl md:text-5xl font-bold">
                <span className="text-yellow-500">Ready-to-use</span>
                <br />
                <span className="text-gray-400">AI trading strategies</span>
              </h3>
              <p className="text-gray-300 text-lg">
                Pre-configured AI strategies optimized for different market conditions and risk levels.
              </p>
              <Button className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold px-8 py-6 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-yellow-500/50">
                <a href="https://users.spreadex.asia" className="text-black font-bold">
                  Start Trading
                </a>
              </Button>
            </div>
            <div className="relative bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-gray-800 group hover:border-yellow-500/50 transition-all duration-500">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-yellow-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-2xl"></div>
              
              <div className="relative">
                <img 
                  src="/images/Design 11.png" 
                  alt="Design 11" 
                  className="w-full h-auto object-contain transform group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* In-app Learning Materials */}
          {/* <div className="grid md:grid-cols-2 gap-12 items-center animate-slide-in-right">
            <div className="order-2 md:order-1 relative h-96 bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-gray-800 p-8 group hover:border-yellow-500/50 transition-all duration-500">
              <div className="relative z-10">
                <h3 className="text-2xl md:text-3xl font-bold mb-4">
                  In-app learning materials
                  <br />
                  and <span className="text-red-500">▶</span> <span className="text-yellow-500">YouTube tutorials</span>
                </h3>
                <p className="text-green-500 text-sm mb-6 font-semibold animate-pulse">Start learning !</p>
                <div className="relative group/video cursor-pointer">
                  <img 
                    src="https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=600&h=300&fit=crop&auto=format" 
                    alt="Learning tutorials" 
                    className="w-full h-48 object-cover rounded-lg transform group-hover/video:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-purple-600/80 to-blue-600/80 rounded-lg flex items-center justify-center group-hover/video:from-purple-700/90 group-hover/video:to-blue-700/90 transition-all duration-300">
                    <div className="text-center transform group-hover/video:scale-110 transition-transform duration-300">
                      <div className="text-5xl mb-3 animate-pulse-play">▶️</div>
                      <div className="text-sm font-bold">AI Trading Tutorial</div>
                      <div className="text-xs text-gray-200 mt-1">Learn in 5 minutes</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="order-1 md:order-2 space-y-6">
              <h3 className="text-4xl md:text-5xl font-bold">
                <span className="text-yellow-500">In-app learning</span>
                <br />
                <span className="text-gray-400">materials and tutorials</span>
              </h3>
              <p className="text-gray-300 text-lg">
                Master AI trading with our comprehensive video tutorials and interactive learning materials.
              </p>
            </div>
          </div> */}

        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px) translateX(0px);
            opacity: 0.3;
          }
          50% {
            transform: translateY(-100px) translateX(50px);
            opacity: 0.8;
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-in-left {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slide-in-right {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes pulse-glow {
          0%, 100% {
            text-shadow: 0 0 20px rgba(234, 179, 8, 0.5);
          }
          50% {
            text-shadow: 0 0 40px rgba(234, 179, 8, 0.8);
          }
        }

        @keyframes bounce-badge {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }

        @keyframes fade-in-scale {
          from {
            opacity: 0;
            transform: scale(0.8);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes pulse-play {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.1);
            opacity: 0.8;
          }
        }

        .animate-float {
          animation: float linear infinite;
        }

        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out;
        }

        .animate-slide-in-left {
          animation: slide-in-left 0.8s ease-out;
        }

        .animate-slide-in-right {
          animation: slide-in-right 0.8s ease-out;
        }

        .animate-pulse-glow {
          animation: pulse-glow 2s ease-in-out infinite;
        }

        .animate-bounce-badge {
          animation: bounce-badge 2s ease-in-out infinite;
        }

        .animate-fade-in-scale {
          animation: fade-in-scale 0.6s ease-out;
          animation-fill-mode: both;
        }

        .animate-bounce-slow {
          animation: bounce-slow 3s ease-in-out infinite;
        }

        .animate-pulse-play {
          animation: pulse-play 2s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};

export default ConfidentTradingSection;
